/* King Product Options (YMQ) fallback.
   Dawn posts new FormData(form). If the personalization inputs render outside that form,
   copy them onto the add request as properties[Key] so they reach /cart.js.
   Inputs already inside the form are left alone. */
(function () {
  if (window.__cclYmq) return;
  window.__cclYmq = true;

  document.addEventListener(
    'formdata',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      var inputs = document.querySelectorAll('.ymq-input-text');
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (form.contains(input)) continue;
        var box = input.closest('.ymq-options-box');
        var raw = box && box.getAttribute('data-name');
        if (!raw) continue;
        var keyMatch = /properties\[(.*)\]/.exec(raw);
        var name = keyMatch ? 'properties[' + keyMatch[1] + ']' : raw;
        event.formData.append(name, input.value);
      }
    },
    true
  );
})();
